import { render, staticRenderFns } from "./LkNotifications.vue?vue&type=template&id=122bbe38&"
import script from "./LkNotifications.vue?vue&type=script&lang=js&"
export * from "./LkNotifications.vue?vue&type=script&lang=js&"
import style0 from "./LkNotifications.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/components/LkNotifications.vue
// module id = 1588
// module chunks = 0